import { render, staticRenderFns } from "./linkMan-add.vue?vue&type=template&id=0f2bb6c8&scoped=true&"
import script from "./linkMan-add.vue?vue&type=script&lang=js&"
export * from "./linkMan-add.vue?vue&type=script&lang=js&"
import style0 from "./linkMan-add.vue?vue&type=style&index=0&id=0f2bb6c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2bb6c8",
  null
  
)

export default component.exports